import { useSelector } from 'react-redux';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { LocalizedSubsectionTitle } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { SelectField } from '@mews-commander/form';
import { getLanguageOptions } from '@mews-commander/legacy-entities/src/ducks/languages';
import { getCultureOptions } from '@mews-commander/legacy-entities/src/ducks/cultures';

export const LanguageAndRegionSettings = () => {
    const languagesOptions = useSelector(getLanguageOptions);
    const culturesOptions = useSelector(getCultureOptions);

    return (
        <Stack vertical spacing="300">
            <LocalizedSubsectionTitle textKey={TextKey.LanguageAndRegionSettings} />

            <SelectField
                name="preferredLanguageCode"
                options={languagesOptions}
                label={<LocalizedText textKey={TextKey.Language} />}
            />

            <SelectField
                name="preferredCultureCode"
                options={culturesOptions}
                label={<LocalizedText textKey={TextKey.DateAndPriceFormat} />}
            />
        </Stack>
    );
};
